"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var delete_1 = require("./delete");
var button_1 = require("../ui/button");
var Footer = function (props) {
    var link = props.link, promise = props.promise, id = props.id, onBack = props.onBack, onDelete = props.onDelete, _a = props.showDelete, showDelete = _a === void 0 ? true : _a, message = props.message;
    return (react_1["default"].createElement(core_1.Box, { display: "flex", justifyContent: "space-between", alignContent: "center" },
        react_1["default"].createElement(button_1.Back, { onClick: onBack || link }),
        showDelete && (react_1["default"].createElement(delete_1.DeleteWRedirect, { promise: promise, id: id, link: link, onDelete: onDelete, message: message }))));
};
exports["default"] = Footer;
